// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CustomEvent } from '@shared/utils/CustomEvents';
import { Resources } from '@shared/localizations/Resources';
import { OrderTypeBaseParameters } from '@shared/commons/cache/OrderParams/order-type/OrderTypeBaseParameters';
import TerceraVisualTradingTemplate from '@front/templates/TerceraVisualTradingTemplate.html';
import { OETIFSelector } from '../trading/OE/OETIFSelector';
import { ContainerControl } from './ContainerControl';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { OCOOrderType } from '@shared/commons/cache/OrderParams/order-type/OCOOrderType';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { BaseSettings } from '@shared/commons/Settings/BaseGeneralSettingsWrapper';
export class TerceraVisualTradingWidget extends ContainerControl {
    constructor() {
        super();
        this.showChartSetting = null;
        this.OnVisualTradingOrderTypeChange = null;
        this.OnIsAllowOTHTradingChanged = new CustomEvent();
        this.OnVisualTradingOrderTypeChange = new CustomEvent();
        this.onCloseCallback = this.onCloseCallback.bind(this);
    }
    getType() {
        return ControlsTypes.TerceraVisualTradingWidget;
    }
    oncomplete() {
        super.oncomplete();
        this.observe('isAllowOTHTrading', () => {
            this.OnIsAllowOTHTradingChanged.Raise();
        });
        this.Controls.OCO.btnInGroup = true;
        this.Controls.single.btnInGroup = true;
        this.Controls.qtyNumeric.settingsUpdate();
        this.localize();
        void this.setWidth();
    }
    setWidth() {
        return __awaiter(this, arguments, void 0, function* (isVisible = false) {
            if (!isVisible) {
                return;
            }
            yield this.set({ width: 0 }).then(() => __awaiter(this, void 0, void 0, function* () {
                const el = this.find('*');
                const w = el.offsetWidth;
                yield this.set({ width: w });
            }));
        });
    }
    oninit() {
        this.on('single_click', () => {
            void this.set({ OCO_checked: false });
            this.OnVisualTradingOrderTypeChange.Raise(true);
        });
        this.on('OCO_click', () => {
            void this.set({ single_checked: false });
            this.OnVisualTradingOrderTypeChange.Raise(false);
        });
        this.on('settings_click', () => {
            this.showSetting();
        });
        this.on('closeClick', this.onCloseCallback);
        this.observe('instrumentItem defaultTif', this.repopulateTIFComboBox);
        this.observe('selectedItem gtdDate', this.updateTIF);
        this.observe('isVisibleOTHTrading', this.onIsVisibleOTHTradingChanged);
        this.observe('accountItem instrumentItem', () => {
            const ins = this.get('instrumentItem');
            const acc = this.get('accountItem');
            if (isNullOrUndefined(ins) || isNullOrUndefined(acc)) {
                return;
            }
            if (!isNullOrUndefined(this.Controls)) {
                this.Controls.qtyNumeric.settingsUpdate();
            }
            const oco = new OCOOrderType();
            const supportedParamObj = new OrderTypeBaseParameters(ins, acc);
            const supportOCO = oco.IsSupported(supportedParamObj);
            void this.set({
                showOCObtns: supportOCO,
                isVisibleOTHTrading: acc.isAllowOTHTrading(ins)
            }).then(() => {
                void this.setWidth(this.get('visible'));
            });
        });
    }
    repopulateTIFComboBox() {
        OETIFSelector.PopuplateTifComboboxAsync([OrderType.Limit, OrderType.Stop], this);
    }
    updateTIF() {
        OETIFSelector.GetAdvancedUpdateTIF(this);
    }
    localize() {
        void this.set({
            singleText: Resources.getResource('panel.newOrderEntry.singleOrderRadio'),
            ocoText: Resources.getResource('OCO')
        });
    }
    showSetting() {
        if (!isNullOrUndefined(this.showChartSetting)) {
            this.showChartSetting();
        }
    }
    show(isVisible) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.set({ visible: isVisible }).then(() => __awaiter(this, void 0, void 0, function* () {
                yield this.setWidth(isVisible);
            }));
        });
    }
    onCloseCallback() {
        this.fire('closeCallback');
    }
    onIsVisibleOTHTradingChanged(value, prevValue) {
        if (value === prevValue) {
            return;
        }
        const isAllowOTHTrading = value ? BaseSettings.isAllowOTHTrading : null;
        this.set('isAllowOTHTrading', isAllowOTHTrading);
    }
}
ContainerControl.extendWith(TerceraVisualTradingWidget, {
    template: TerceraVisualTradingTemplate,
    data: function () {
        return {
            top: 0,
            left: 0,
            height: 32,
            movable: true,
            visible: false,
            isVisibleOTHTrading: false,
            isAllowOTHTrading: null,
            ocoText: '',
            singleText: '',
            single_checked: true,
            OCO_checked: false,
            instrumentItem: null,
            accountItem: null,
            showOCObtns: true,
            showLeverage: false,
            tif: null,
            items: null,
            gtdDate: null,
            orderTypeId: null,
            selectedItem: null,
            closeCallback: null,
            // TODO. Remove. Ugly.
            defaultTif: null
        };
    }
});
